import { isPlatformServer } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss'],
})
export class ScrollTopComponent implements OnInit, AfterViewInit, OnDestroy {
  private scrollSubs!: Subscription;

  @ViewChild('scrollTop') scrollTopRef!: ElementRef;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private renderer: Renderer2
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    this.scrollSubs = fromEvent(window, 'scroll').subscribe({
      next: () => {
        if (window.scrollY > 10) {
          this.renderer.addClass(this.scrollTopRef.nativeElement, 'show');
          return;
        }
        this.renderer.removeClass(this.scrollTopRef.nativeElement, 'show');
      },
    });
  }

  onScrollToTop() {
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  ngOnDestroy() {
    this.scrollSubs?.unsubscribe();
  }
}
